<template>
  <section class="support" @click="hideSupport">
    <div class="content">
      <p class="text">{{ tipsMsg }}</p>
      <p class="open_app" @click="myOpenApp">打开南方+，可再打榜+2票</p>
    </div>
  </section>
</template>
<script>
import { newOpenApp } from "@/js/newOpenApp";
export default {
  props: {
    nfh: Object,
    tipsMsg: String,
    cityRankInfo:{}
  },
  data() {
    return {};
  },
  methods: {
    hideSupport() {
      this.$emit("popSupport", { bool: false });
    },
    myOpenApp() {
      console.log('supootthis.cityRankInfo',this.cityRankInfo)
      newOpenApp(this.nfh.columnId, "cityRank", false,this.cityRankInfo,24);
    }
  },
  mounted(){
    //  console.log('supoot',this.cityRankInfo)
  }
};
</script>
<style lang="less" scoped>
@import url("../less/mixin.less");
.support {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.content {
  .middle;
  width: 2.96 * 2rem;
  height: 1.78 * 2rem;
  background: url("../img/champion_bg.png") no-repeat center 0.2 * 2rem;
  background-size: 1.11 * 2rem 0.91 * 2rem;
  border-radius: 5px;
  background-color: #fff;
}
.text {
  font-size: 0.4rem;
  line-height: 0.56rem;
  margin: 1rem auto;
  text-align: center;
  color: #333;
}
.open_app {
  width: 2.66 * 2rem;
  height: 0.35 * 2rem;
  margin: 0 auto;
  border-radius: 5px;
  background-color: #f64e45;
  color: #fff;
  font-size: 0.16 * 2rem;
  text-align: center;
  line-height: 0.35 * 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/support.vue